module.exports = __webpack_public_path__ + "static/media/golfinho_de_risso.d99b0d6f.png";